"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deployment = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class Deployment extends Base_1.Base {
    name = '';
    changeId = '';
    notes = '';
    created = null;
    approved = 0;
    approved_by = '';
    deployed = null;
    running = false;
    status = '';
    pages = {};
    allPages = true;
    feedbackId = '';
    keepIds = [];
    agents = [];
    followers = [];
    roles = [];
    _m = ['name'];
    constructor(data, olMap) {
        super('deployments', 10);
        (0, Common_1.setObjectProperties)(this, data, olMap, Deployment);
    }
    toString() {
        return `Deployment: ${this.name}`;
    }
    async save(parent) {
        if (!this.id) {
            this.setID();
        }
        if (parent && parent._docRef) {
            this._docRef = parent._docRef.collection('cms').doc('root').collection(this._type).doc(this.id);
        }
        if (!this._docRef) {
            throw `Cannot save! No document reference.`;
        }
        else {
            if (!this.created) {
                this.created = Date.now();
            }
            return super.save();
        }
    }
}
exports.Deployment = Deployment;
index_1.olm.deployments = (ref, map) => {
    return new Deployment(ref, map);
};
